import { Anchor, AnchorModel, Link } from '@bpba/ui-components';
import { FC } from 'react';
import styled from 'styled-components';
import { TypographyProps, typography, ColorProps, color, PaddingProps, padding } from 'styled-system';

type Props = {
  children?: string;
  href?: string;
};

export const TextLink: FC<Props> = ({ children, href }) => {
  const data = new AnchorModel(0, undefined, new Link(href, false, false, undefined), undefined);

  return (
    <StyledAnchor data={data} fontWeight={700} color={'secondary.1'} paddingBottom="0px" borderBottomWidth="1px" borderBottomStyle="solid" borderBottomColor={'secondary.1'}>
      {children}
    </StyledAnchor>
  );
};

type StyledAnchorProps = TypographyProps & ColorProps & PaddingProps;

const StyledAnchor = styled(Anchor)<StyledAnchorProps>(typography, color, padding);
